import axios, { CancelToken } from 'axios';
import { ISolicitacaoDeRecuperacaoReceitas, IUploadHistorico } from '../../../../pages/RecuperacaoReceitas/interfaces';
import { GATEWAY_API_URL } from "../../../request/urls";
import { getToken } from "../../../token";

class RecuperacaoReceitasService {
    private baseURL = `${GATEWAY_API_URL}/recuperacao-receita`

    async getStatusSolicitacoes(signal?: CancelToken): Promise<{ status: string[] }> {
        const { data } = await axios.get(`${this.baseURL}/solicitacoes/status`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getSolicitacoes(signal?: CancelToken): Promise<Array<ISolicitacaoDeRecuperacaoReceitas>> {
        const { data } = await axios.get(`${this.baseURL}/solicitacoes`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getQuantidadeSolicitado(signal?: CancelToken): Promise<{ quantidade: number }> {
        const { data } = await axios.get(`${this.baseURL}/solicitacoes/contagem `, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getHistoricoUpload(signal?: CancelToken): Promise<Array<IUploadHistorico>> {
        const { data } = await axios.get(`${this.baseURL}/planilhas`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async postObservacaoSolicitacao(_id: string, id_ibge: string, usuario_nome: string | null, observacao?: string, signal?: CancelToken) {
        const { data } = await axios.post(`${this.baseURL}/solicitacoes/${id_ibge}/observacoes?id=${_id}&observacao=${observacao}&usuario_nome=${usuario_nome}`,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                    'Content-Type': 'multipart/form-data',
                },
                cancelToken: signal,
            }
        );

        return data;
    }

    async uploadFile(fonte_id: number, formData: FormData, usuario_nome: string | null, signal?: CancelToken) {
        const { data } = await axios.post(`${this.baseURL}/planilhas?fonte_id=${fonte_id}&usuario_nome=${usuario_nome}`,
            formData,
            {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                    'Content-Type': 'multipart/form-data',
                },
                cancelToken: signal,
            }
        );

        return data;
    }

    async putStatusSolicitacao(_id: string, status: string, id_ibge: string, usuario_nome: string | null, signal?: CancelToken) {
        const { data } = await axios.patch(`${this.baseURL}/solicitacoes/${id_ibge}/status?status=${status}&id=${_id}&usuario_nome=${usuario_nome}`,
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                },
                cancelToken: signal
            }
        );

        return data;
    }
}

export default new RecuperacaoReceitasService();
